import { discoverGateway } from "./discovery.js";
import { LocalCliError } from "./errors.js";

/**
 * Refuse to proceed unless the m8t platform is deployed. The footgun
 * fix (a worker deploy attempted before `m8t deploy` finished hit an
 * unreachable Foundry and failed cryptically). A discoverable gateway
 * (Container App tagged m8t=gateway) is the definitive "platform is
 * live" signal. ZERO → PLATFORM_NOT_LIVE; MULTIPLE → live (ambiguity is the
 * caller's to resolve later); other discovery errors propagate unchanged.
 */
export async function assertPlatformLive(opts: { subscriptionId?: string; interactive: boolean }): Promise<void> {
  try {
    await discoverGateway({ subscriptionId: opts.subscriptionId, interactive: opts.interactive });
  } catch (e) {
    if (e instanceof LocalCliError) {
      if (e.code === "GATEWAY_DISCOVERY_MULTIPLE") return; // platform IS live, just >1
      if (e.code === "GATEWAY_DISCOVERY_ZERO") {
        throw new LocalCliError({
          code: "PLATFORM_NOT_LIVE",
          message: "The m8t platform isn't deployed yet — there is no gateway in this subscription.",
          hint: "Deploy it first: run the local bootstrap (`m8t bootstrap launch …`) and wait for `m8t bootstrap status` to reach done. If it's in another subscription, run `az account set --subscription <id>`.",
          cause: e,
        });
      }
    }
    throw e;
  }
}
